import styled from 'styled-components'

import { InputBase } from '../InputBase'

export const InputBaseStyled = styled(InputBase)`
  .MuiInputBase-root {
    align-items: baseline;
  }
`
